import { VALUE_NOT_EMPTY } from 'constants/errors';
import { BaseCustomValidator } from '../types';

/**
 * As of 08/07/20, requireEmpty may not be used at all.
 */
const requireEmpty: BaseCustomValidator<any> = (validateModel, validate) => (value: any) => {
  if (
    value === null
    || value === undefined
    || value === ''
    || (Array.isArray(value) && value.length === 0)
    || (value.constructor === Object && Object.keys(value).length === 0)
  ) {
    return null;
  }

  return VALUE_NOT_EMPTY;
};

export default requireEmpty;
